define('components/util/graphutil',[
    'jquery'
],function($){

    function graphUtil(  ){
        var _this = this;
        var sourceURL = '/gui/js/static/d3.min.js';
        var d3Script;

        /** load the d3 library
        */
        var loadLibrary = function() {
          return window.d3;
        };


        var createBox = function(elm, viewBox, margin){


          var vis = elm.append("svg")
            .attr('preserveAspectRatio','xMinYMin meet')
            .attr("viewBox", viewBox.x + " " + viewBox.y + " " + viewBox.width + " " + (parseInt(viewBox.height)+70))
            .append("g")
            .attr("class", "graph")
            .attr("transform", "translate(0,0)");

            if(detectIE()){
              elm.select("svg").attr("height", (parseInt(viewBox.height)+70));
            }

            createDefs(viewBox, margin);
          return vis;
        };

        /**
         * create the definitions like glows
         */
        var createDefs = function(viewBox, margin) {
          var defs = d3.select("svg").append("defs");

          //viewbox mask
          var mask = d3.select("svg defs").append("mask").attr("id", "viewMask");
          var maskRect = mask.append("rect");
          setAttrs(maskRect, {"width": viewBox.width, "height": viewBox.height, "y": margin, "x": margin, "fill": "white"});

          //glow
          var filter = defs.append("filter")
            .attr("id","glow");

          filter.append("feGaussianBlur")
            .attr("class", "blur")
            .attr("stdDeviation","2")
            .attr("result","coloredBlur");

          var feMerge = filter.append("feMerge");
          feMerge.append("feMergeNode")
            .attr("in","coloredBlur");
          feMerge.append("feMergeNode")
            .attr("in","SourceGraphic");


        };

        /**
         * when the text is wider than given width, ellipsis the text
         */
        var ellipsisText = function(elm, width, text) {
          if(!text){
            text = "";
          }
          elm = d3.select(elm);
          elm.text(text);

          var words = text.split(" ").reverse();
          var word;
          var line = [];
          while (words.length > 0) {
            word = words.pop();
            line.push(word);
            elm.text(line.join(" "));

            if (elm.node().getComputedTextLength() > width-70) {
              line.pop();
              elm.text(line.join(" ") + "...");
              break;
            }
          }

          return elm.text();
        };

        var setHeight = function(height){
          var svg = d3.select("svg");
          svg.attr("viewBox", function(d){
            return "0 0 " + svg.node().getBBox().width + " " + height;
          });
          //svg.attr("height", height);
        };

        var showLoader = function (el){
          var height = $(el).height();
          var width = $(el).width();

          var loader = document.createElement('div');
          loader = $(loader);
          loader.addClass("loader");
          loader.width(width);
          loader.height(height);

          loader.html('<span class=""><i class="ico ico-spinner ico-spin"></i></span>');

          loader.prependTo($(el));
        };

        var removeLoader = function (el){
          $(el).find(".loader").remove();
        };



        /**
         * detect IE
         * returns version of IE or false, if browser is not Internet Explorer
         */
        function detectIE() {
          var ua = window.navigator.userAgent;

          var msie = ua.indexOf('MSIE ');
          if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
          }

          var trident = ua.indexOf('Trident/');
          if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
          }

          // other browser
          return false;
        }

        /**
         * set multiple attrs for a svg elements
         * @param {object} attrs object with key values of attributes
         */
        function setAttrs(elm, attrs){
          for (var property in attrs) {
            if (attrs.hasOwnProperty(property)) {
              elm.attr(property, attrs[property]);
            }
          }
        }

        /**
         * convert the KVK to a dossier number
         * @param  {str} kvk
         * @return {string}     dossiernumber
         */
        function convertKvk2DossierNr(kvk){
          var dossierNr = kvk;
          if(String(kvk).length > 8){
            dossierNr = String(kvk).substr(0,8);
          }

          return dossierNr;
        }

        /**
         * converts the int to string and makes sure that the string is the given length
         * by prepending the string with zero's
         * @param  {int} int    [description]
         * @param  {int} length the length of the string
         * @return {string}
         */
        function leadingZero(int, length){
          var str = "" + int;
          while(str.length < length){
            str = "0" + int;
          }
          return str;
        }

        return {
          loadLibrary: loadLibrary,
          createBox: createBox,
          ellipsisText: ellipsisText,
          setHeight: setHeight,
          showLoader: showLoader,
          removeLoader: removeLoader,
          setAttrs: setAttrs,
          convertKvk2DossierNr: convertKvk2DossierNr,
          leadingZero: leadingZero
        };

    }
    return graphUtil();
});

